import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';

import { cn } from '../../lib/utils';

const buttonVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none',
  {
    variants: {
      variant: {
        primary:
          'min-h-16 px-6 py-5 rounded-2xl bg-main-color text-white text-lg font-normal hover:bg-terciary-color transition-all duration-200 ease-in-out',
        secondary:
          'min-h-16 px-6 py-5 rounded-2xl bg-white border-2 border-main-color font-normal text-main-color text-lg hover:bg-gray-100 transition-all duration-200 ease-in-out',
        default:
          'bg-primary text-primary-foreground shadow hover:bg-primary/90 ',
        destructive:
          'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90',
        outline:
          'min-h-16 px-6 py-5 border-2 text-white rounded border-white bg-transparent hover:opacity-60 transition-all duration-200 ease-in-out',
        ghost: 'hover:bg-accent hover:text-accent-foreground',
        link: 'text-primary underline-offset-4 hover:underline',
        icon: 'text-white hover:opacity-60 transition-all duration-200 ease-in-out',
      },
      size: {
        default: 'h-9 px-4 py-2',
        sm: 'h-8 rounded-md px-3 text-xs',
        lg: 'h-10 rounded-2xl px-8',
        icon: 'h-9 w-9',
      },
      disabled: {
        true: 'bg-[#696969] text-white pointer-events-none', // Sem opacidade reduzida
        false: '',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
      disabled: false,
    },
  }
);


const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, disabled: props.disabled, className }))}
        ref={ref}
        disabled={props.disabled}
        {...props}
      />
    );
  }
);
Button.displayName = 'Button';

export { Button, buttonVariants };
